import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_SOCKET_URL, {
  // Allow polling to establish the connection, then auto-upgrade to websocket.
  // Websocket-only fails outright if a proxy momentarily blocks the upgrade.
  transports: ['polling', 'websocket'],
  path: '/socket.io',
});

export default socket;
